import { render, staticRenderFns } from "./ProductSearchByImage.vue?vue&type=template&id=238b3ba2&scoped=true"
import script from "./ProductSearchByImage.vue?vue&type=script&lang=js"
export * from "./ProductSearchByImage.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchByImage.vue?vue&type=style&index=0&id=238b3ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b3ba2",
  null
  
)

export default component.exports